import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { LaunchScene } from './scenes/LaunchScene';
import { StartScene } from './scenes/StartScene';
import { TitleScene } from './scenes/TitleScene';
import { CharacterCreatorScene } from './scenes/CharacterCreatorScene';
import { AnimalSelectorScene } from './scenes/AnimalSelectorScene';
import { LevelIntroScene } from './scenes/LevelIntroScene';
import { GameScene } from './scenes/GameScene';
import { TimesTableScene } from './scenes/TimesTableScene';
import { BossScene } from './scenes/BossScene';
import { GameOverScene } from './scenes/GameOverScene';
import { WinScene } from './scenes/WinScene';
import { DebugMenuScene } from './scenes/DebugMenuScene';
import { TwoPlayerSetupScene } from './scenes/TwoPlayerSetupScene';
import { TwoPlayerRaceScene } from './scenes/TwoPlayerRaceScene';
import { TwoPlayerBossScene } from './scenes/TwoPlayerBossScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: '#1d1d1d',
  // We don't play any sounds, so disable the audio system. This stops
  // Phaser from consuming the user-activation token to unlock the
  // AudioContext on the first tap (which broke the fullscreen request
  // on the StartScene).
  audio: {
    noAudio: true,
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 1280,
    height: 720,
    expandParent: true,
  },
  input: {
    activePointers: 3,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [
    BootScene,
    LaunchScene,
    StartScene,
    TitleScene,
    CharacterCreatorScene,
    AnimalSelectorScene,
    LevelIntroScene,
    GameScene,
    TimesTableScene,
    BossScene,
    GameOverScene,
    WinScene,
    DebugMenuScene,
    TwoPlayerSetupScene,
    TwoPlayerRaceScene,
    TwoPlayerBossScene,
  ],
};

new Phaser.Game(config);
